import axios from "axios";
import { useMutation, useQueryClient } from "react-query";

import { toast } from "../../../../components/toastNotification";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL +
  "/BusinessLicensePermits/DeactivateBusLicensePermit";

export interface DeactivateBLPResponse {
  success: boolean;
  recordIds: number[];
}

export const deactivateBLP = async (
  recordIds: number[],
): Promise<DeactivateBLPResponse> => {
  if (!recordIds || recordIds.length === 0) {
    throw new Error(
      "At least one Business License and Permit record is required.",
    );
  }

  const response = await axios.put<DeactivateBLPResponse>(
    apiBaseUrl,
    recordIds,
  );

  return response.data;
};

export const useDeactivateBLP = () => {
  const queryClient = useQueryClient();

  return useMutation<DeactivateBLPResponse, unknown, number[]>(deactivateBLP, {
    onSuccess: async () => {
      await queryClient.invalidateQueries("GetBLPTable");

      await queryClient.invalidateQueries("BLPDashboard");

      await queryClient.invalidateQueries("GetBLPbyId");

      toast.fire(
        "Success",
        "Business Licenses and Permits were deactivated successfully",
        "success",
      );
    },

    onError: (error: any) => {
      const message =
        error?.response?.data?.message ??
        error?.response?.data ??
        error?.message ??
        "Cannot deactivate Business Licenses and Permits.";

      toast.fire("Bulk deactivation failed", String(message), "error");
    },
  });
};
